module.exports = __webpack_public_path__ + "img/1.d77c6c54.png";